module.exports = __webpack_public_path__ + "static/img/core-item-2.69b9be6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedProcessPhone/core-item-2.png
// module id = tYnR
// module chunks = 0